import { css } from "@emotion/react";

const nav = css`
  width: 100%;
`;

const subHead = ({ theme }) => css`
  padding-top: 0;
  margin-top: 48px;
  font-size: 26px;
  text-align: center;

  @media (min-width: ${theme.screenSizes.mdMax}) {
    margin-top: 32px !important;
    font-size: 32px;
    text-align: start;
  }
`;

export const addStyles = {
  nav,
  subHead,
};
